module.exports = __webpack_public_path__ + "static/img/label-03.b490694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-03.png
// module id = F9rd
// module chunks = 150